export const CONNECTIONS_QUERY_KEY = 'connections'
export const PROVIDERS_QUERY_KEY = 'providers'

export const getConnectionsQueryKey = (userId: string | undefined) => [CONNECTIONS_QUERY_KEY, userId] as const
export const getProvidersQueryKey = (userId: string | undefined) => [PROVIDERS_QUERY_KEY, userId] as const
